import {NgModule} from "@angular/core";
import {RouteReuseStrategy, RouterModule, Routes} from "@angular/router";
import {CommonModule, HashLocationStrategy, LocationStrategy} from "@angular/common";
import {AuthService} from "@fedeltapointofsale/data-client";
import {LoginPageComponent} from "./login/login-page/login-page.component";
import {
    FedeltaSupportLoginPageComponent
} from "./login/fedelta-support-login-page/fedelta-support-login-page.component";
import {
    UserProfileCompletionPageComponent
} from "./user-profile/user-profile-completion-page/user-profile-completion-page.component";
import {UserProfileSetupPageComponent} from "./user-profile/user-profile-setup-page/user-profile-setup-page.component";
import {RoutingDiscoveryService} from "./routing-discovery.service";
import {AppRouteReuseStrategy} from "./app-route-reuse-strategy";

const routes: Routes = [
    {
        component: LoginPageComponent,
        path: "login"
    },
    {
        component: FedeltaSupportLoginPageComponent,
        path: "support-login/:token"
    },
    {
        component: UserProfileCompletionPageComponent,
        path: "profile-completion"
    },
    {
        component: UserProfileSetupPageComponent,
        path: "profile-setup"
    },
    {
        path: "",
        pathMatch: "full",
        redirectTo: "main"
    }
];

@NgModule({
    imports: [
        CommonModule,
        RouterModule.forRoot(routes)
    ],
    exports: [RouterModule],
    providers: [
        {
            provide: LocationStrategy,
            useClass: HashLocationStrategy
        },
        RoutingDiscoveryService,
        {
            provide: RouteReuseStrategy,
            useClass: AppRouteReuseStrategy,
            deps: [AuthService]
        }
    ]
})
export class AppRoutingModule {
}
